<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="101 Things to Do With Canned Biscuits">
<div class="dedication">
<p>
<em>To my family: Thank you for your love and support. I could not have done this without you! All my love, Toni</em>
</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?77c451bc